import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, EmailValidator, Validators } from "@angular/forms";
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { setOffsetToParsedOffset } from 'ngx-bootstrap/chronos/units/offset';
import { ServiceService } from '../../service.service';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { GlobalConstants } from '../../global-config'
import { MetaServiceService } from '../../meta-service.service';

declare var $;

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
  // for number increment/decrement
  count = 1;
  division: any;

  safeURL; //youTube Video URL //
  yearly: any = 9180;
  monthly: any = 900;
  yearlyD: any = 124.87;
  monthlyD: any = 12.23;
  yUser: any = 1;
  mUser: any = 1;
  yearlyDF: any = 124.87;
  monthlyDF: any = 12.23;
  qUser: number;
  quarterlyD: number;
  quarterly: number;
  quarterlyDF: string;
  allPlan: any[];
  current_INR_USD_Rate: any;
  isFree = true;
  isProMonthly = false;
  isProQuarterly = false;
  isProYearly = false;
  selectedDuration = 30;
  amountQuarterlyINR: number;
  disQuarterly = 0;
  disYearly = 0;
  disMonthly = 0;
  selectedPeriod = "Monthly";
  decrypted: any;
  currency_type: string = 'inr';
  discount: any;
  finalAmount: number;

  userdata: any;
  company_id: any;
  isLoggedin: any;
  payment_currency_type: string = 'inr';
  // currency_type : string = 'inr' ; 
  activePlanIsFree = false;
  activePlanIsTrial = false;
  activePlanInfoData = 0;
  customPlanDetails: any;
  selectedCurrencyType = '₹'
  constructor(
    private meta: Meta,
    private title: Title,
    private _sanitizer: DomSanitizer,
    public service: ServiceService,
    public router: Router,
    private metaService: MetaServiceService) {

    //  SEO Meta Description
    this.meta.addTags([
      { name: 'description', content: 'Which type of questions do you want to plan for your survey? Multiple choice questions, Picture choice questions. Demographic questions.' },
      { name: 'author', content: 'CViewSurvey' },
      { 
        name: 'keywords',
        content: 'Collect data , Analysis data , white label survey , Track customer feedback , Survey , Feedback application' ,  },
    ]);

    this.setTitle('Best plan for survey | Survey questions types');
    // End SEO Meta Description

    // You Tube Video Description
    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/EsPq62yE3AE');
    // End You Tube Video Description

  }


  // SEO Page Title Description
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  // SEO Page Title Description


  ngOnInit(): void {
    // for create canonical link 
    this.metaService.createCanonicalURL();
    
    // for tooltip
    $('body').tooltip({ selector: '[data-toggle="tooltip"]' });


    // fix plan header
    // this.categoryList();
    $(window).scroll(function () {
      var topMargin = $('#planBanner').innerHeight() + $('#planHeader').innerHeight();
      var tableHeight = $('#tableLista').innerHeight();
      if ($(window).scrollTop() >= topMargin) {
        $(".sticky-plan-header").addClass("fixed-header");
      } else {
        $(".sticky-plan-header").removeClass("fixed-header");
      }
      if ($(window).scrollTop() >= topMargin + tableHeight) {
        $(".sticky-plan-header").removeClass("fixed-header");
      } 
    });

    // scroll fixed
    var target = $("#tableFixed");
    $("#tableLista").scroll(function() {
      target.prop("scrollTop", this.scrollTop);
      target.prop("scrollLeft", this.scrollLeft);
    });

    
    //this.planDurationChange(30);
    // get all plan function triggering
    // this.getAllPlan();
    this.getCurrentIP();
    this.getAllPublicServices();
    // get all discount function triggering
    this.getAllDiscount()
    this.getPlanModuleTypesWithServices();
    this.getAllQuestionType();
    // currency coverter 
    // this.service.currency().subscribe((data: any) => {
    //   // console.log("1 USD = "+data.INR_USD.toFixed(2)+" Rupees");
    //   this.current_INR_USD_Rate = data.INR_USD;
    // });
    // (error) => {
    //   console.log('no data found');
    // };

  }

  //============================== getAllPublicServices========================================================================
  allPublicServices = [];
  getAllPublicServices() {
    this.service.AllPublicServices().subscribe((data: any) => {
     // console.log("ALL SERVICES ::", data.data)
      this.allPublicServices = data.data;
    })
  }
  //========================================  getCurrentIP  ====================================================
  getCurrentIP() {
    this.service.getCurrentIPAddress().subscribe((result: any) => {
    // result = { "ip": "157.34.179.186" }; //India
    // result = { "ip": "79.141.162.81" }; //US
    // result={"ip":"192.206.151.131"}  //Canada
    // result = {"ip":"83.110.250.231"}//Dubai 
    //  result = {"ip":"86.106.34.164"}//Romania
    //  result = {"ip":"93.184.99.93"}//Polland
    console.log("getCurrentIPAddress", result);
    this.service.getContryCodeByIP(result).subscribe((countryInfo) => {
      console.log("getContryCodeByIP", countryInfo);
      this.getAllPlan(countryInfo.geo.country)
    });//getContryCodeByIP  
    (error) => {
      console.log('API Error', error);
    };
    });//getCurrentIPAddress
  }
  //========================================  getAllPlan  ===========================================================
  colspanDynamicLength: number;
  getAllPlan(countryCode) {
    // console.log("In get Plan before service")
    this.service.pricingg(countryCode).subscribe((data: any) => {
      // console.log("In get Plan pricing1 service")

       console.log(data.data);
      this.allPlan = data.data.filter(p => p.planSubTypeId !=5)
      this.colspanDynamicLength = data.data.length + 1;
      this.allPlan = this.allPlan.filter((plan) => {
        if (plan.currencyDetails.length == 0 && plan.planSubTypeId == 2) {

          // return  plan
        } else {

          return plan
        }
      })
      console.log(this.allPlan);

    });
    (error) => {
      console.log('no data found');
    };
    console.log("out of getAllPlan")
    
  }
  //========================================  discountedPlanAmountINR  ====================================================
  totalCalculatedAmount = 0;
  selectedPlanAmount = 0
  selectedPlanDiscount = 0
  selectedPlanTax  = 0
  discountedPlanAmount(amount, discount, tax) {
      // console.log(amount,discount,tax);

      this.selectedPlanAmount = amount
      this.selectedPlanDiscount = discount
      this.selectedPlanTax = tax
      let duration = this.selectedDuration;
      let existingPlanAmount = 0;
      // console.log(amount, discount)
      if (duration == 14) {
        existingPlanAmount = amount - ((amount * discount) / 100)
        // this.totalCalculatedAmount = Math.round(existingPlanAmount + ((existingPlanAmount*tax)/100)); //* this.count
        this.totalCalculatedAmount = Math.round(existingPlanAmount) //* this.count
        return this.totalCalculatedAmount;
      }
      if (duration == 30) {
        existingPlanAmount = amount - ((amount * discount) / 100)
        // this.totalCalculatedAmount = Math.round(existingPlanAmount+ ((existingPlanAmount*tax)/100)); //* this.count
        this.totalCalculatedAmount = Math.round(existingPlanAmount)//* this.count
        return this.totalCalculatedAmount;
      }
      if (duration == 90) {
       discount = this.disQuarterly
        amount= amount *3;
        existingPlanAmount = amount - ((amount * discount) / 100)
        
        // this.totalCalculatedAmount = Math.round(existingPlanAmount+ ((existingPlanAmount*tax)/100)); //* this.count
        this.totalCalculatedAmount = Math.round(existingPlanAmount)//* this.count
        return this.totalCalculatedAmount;
      }
      if (duration == 365) {
       discount = this.disYearly;
        amount= amount *12;
        existingPlanAmount = amount - ((amount * discount) / 100)
        // this.totalCalculatedAmount = Math.round(existingPlanAmount+ ((existingPlanAmount*tax)/100)); //* this.count
        this.totalCalculatedAmount = Math.round(existingPlanAmount)//* this.count
        return this.totalCalculatedAmount;
      }
  }
  //============================================================================================ 

  // feature list collapse function
  expandFeature() {
    $('.plan-wrapper .plan-wrapper-list.shrink').addClass('expand');
    $('#expandBtn').hide();
  }

  // increment and decrement 
  increment() {
    this.count++;
    if (this.count == 21) {
      this.count--;
      window.scroll(0, 1500);
    }
  }
  decrement() {
    if (this.count > 1) this.count--;
  }

  // plan price calculation
  calc() {
    return this.current_INR_USD_Rate;
  }

  //currencyType
  currencyType(event) {
    this.currency_type = event.target.value
    console.log(this.currency_type);
    return this.currency_type;

  }

  // get all plan API 
  // getAllPlan1() {
  //   this.service.pricing().subscribe((data: any) => {
  //     this.allPlan = data.data;
  //     console.log(this.allPlan);
  //   });
  //   (error) => {
  //     console.log('no data found');
  //   };
  // }


  // get discount 
  
  //=====================================================================================================
  getAllDiscount() {
    this.service.discount().subscribe((data: any) => {
      this.discount = data.data;
       console.log(this.discount);
      if (data.data[0].id == 1) {
        this.disQuarterly = data.data[0].discount;
      }
      if (data.data[1].id == 2) {
        this.disYearly = data.data[1].discount;
      }
    });
    (error) => {
      console.log('no data found');
    };
  }
  //=====================================================================================================

  //for Dynamic discounts
  getDiscount(discount_duration) {
    if (discount_duration == 'Monthly') {
      return this.disMonthly
    }
    if (discount_duration == 'Quaterly') {
      return this.disQuarterly
    }
    if (discount_duration == 'Yearly') {
      return this.disYearly
    }
  }

  //=================================== planDurationChange ==================================================================
  selectedTimePeriodAfterPlanAmount = 'Month';
  planDurationChange(duration) {
    this.selectedDuration = duration;
    if (duration == 30) {
      this.selectedPeriod = "Monthly";
      this.selectedTimePeriodAfterPlanAmount = "Month";
      this.discountedPlanAmount(this.selectedPlanAmount,this.selectedPlanDiscount,this.selectedPlanTax)
    }
    else if (duration == 90) {
      this.selectedPeriod = "Quarterly";
      this.selectedTimePeriodAfterPlanAmount = "Quarter";
      this.discountedPlanAmount(this.selectedPlanAmount,this.selectedPlanDiscount,this.selectedPlanTax)
    }
    else if (duration == 365) {
      this.selectedPeriod = "Yearly";
      this.selectedTimePeriodAfterPlanAmount = "Year";
      this.discountedPlanAmount(this.selectedPlanAmount,this.selectedPlanDiscount,this.selectedPlanTax)
    }
  }
  //=====================================================================================================

  //=====================================================================================================
  tryNowPlan(){
    // window.location.href =  GlobalConstants.domainURL+`/signup`;// 'http://cviewsurvey.coworrk.com/signup';
    window.open(GlobalConstants.domainURL+`/signup`, '_blank');
    // let planInfo = {
    //     plan_id: 5,
    //     user_count: 1,
    //     plan_amount: 0,
    //     duration: 14,
    //     discount: 0,
    //     currency_type: 'inr'
    //   }
    //   console.log(planInfo);
  
    //   let replacedkeyByDollerAlpha = this.service.getEncryptKey(planInfo);
     
    //   window.location.href = GlobalConstants.domainURL + '?key=' + replacedkeyByDollerAlpha;
      // window.location.href = 'http://localhost:4201?key='+ encrypted;
  }
  //=====================================================================================================
  //============================================ purchase plan   ==========================================================
  purchasePlan(planId,planSubTypeId, amount,currency_code,tax) {
    let finalDiscount = 0;
    if (this.selectedPeriod == 'Quarterly') {
      finalDiscount = this.disQuarterly;
    }
    else if (this.selectedPeriod == 'Yearly') {
      finalDiscount = this.disYearly;

    }

    let data = {
      plan_amount: Math.round(amount+(amount * tax)/100) ,
      planId: planId,
      duration: this.selectedDuration,
      user_count: this.count,
      discount: finalDiscount,
      currency_type: currency_code.toLowerCase(),
      planSubTypeId:planSubTypeId,//this.payment_currency_type ? this.payment_currency_type : 'inr',
      tax:tax    
    }
    console.log(data);
    this.setPlanInfo(data);
    

  }

  purchasePlanThree(planId,planSubTypeId, amount,currency_code,tax){
    let finalDiscount = 0;
    if (this.selectedPeriod == 'Quarterly') {
      finalDiscount = this.disQuarterly;
    }
    else if (this.selectedPeriod == 'Yearly') {
      finalDiscount = this.disYearly;

    }

    let data = {
      plan_amount: Math.round(amount+(amount * tax)/100) ,
      planId: planId,
      duration: this.selectedDuration,
      user_count: this.count,
      discount: finalDiscount,
      currency_type: currency_code.toLowerCase(),
      planSubTypeId:planSubTypeId,//this.payment_currency_type ? this.payment_currency_type : 'inr',
      tax:tax    
    }
    console.log(data);
    this.setPlanInfo(data);
    
  }

  //=====================================================================================================
    // selected plan info
    async setPlanInfo(planInfo) {
      // console.log(plan_id);
      // console.log(amountInINR);
      // console.log(amountInUSD);
      // let finalAmount
      // if (this.currency_type == 'usd') {
      //   finalAmount = amountInUSD
      // }
      // else {
      //   finalAmount = amountInINR.toFixed(0)
  
      // }
  
      // let finalDiscount = 0;
      // if (this.selectedPeriod == 'Quarterly') {
      //   finalDiscount = this.disQuarterly;
      // }
      // else if (this.selectedPeriod == 'Yearly') {
      //   finalDiscount = this.disYearly;
  
      // }
  
      // let planInfo = {
      //   plan_id: plan_id,
      //   user_count: this.count,
      //   plan_amount: finalAmount,
      //   duration: this.selectedDuration,
      //   discount: finalDiscount,
      //   currency_type: this.currency_type
      // }
      console.log(planInfo);
      let replacedkeyByDollerAlpha = await this.service.getEncryptKey(planInfo);
      // window.location.href = 'http://cviewsurvey.coworrk.com' + '?key=' + replacedkeyByDollerAlpha;
     // window.location.href = GlobalConstants.domainURL + '?key=' + replacedkeyByDollerAlpha;
      let URL = GlobalConstants.domainURL+'/signup' + '?key=' + replacedkeyByDollerAlpha;
      // window.location.href = 'http://localhost:4200' + '?key=' + replacedkeyByDollerAlpha;
      // window.location.href = 'http://localhost:4201?key='+ encrypted;
      console.log( GlobalConstants.domainURL)
      window.open(URL, '_blank');
    }
  
  //=====================================================================================================
  tryItNow(){
    //window.location.href = GlobalConstants.domainURL +'/signup';
    window.open(GlobalConstants.domainURL +'/signup', '_blank');
  }
  //=====================================================================================================
  planModuleWithServices = [];
  getPlanModuleTypesWithServices(){
    this.service._getPlanModulesWithServices().subscribe((data: any) => {
   console.log(":::: _getPlanModulesWithServices ::::",data.data);
    this.planModuleWithServices = data.data;
   
    });
    (error) => {
      console.log('no data found',error);
    };
  }
  //===================================================================================================== // not is use as of now
  questionTypes(questions){
    let qType = [];
    let allQuestions = questions.split(',').map(Number);
    allQuestions.map((AQT)=>{
      if(AQT==1){
        return qType.push('Multiple Choice ')
      }
      if(AQT==2){
        return qType.push('Opinion Scale ')
      }
      if(AQT==3){
        return qType.push('Star Rating ')
      }
      if(AQT==4){
        return qType.push('NPS ')
      }
      if(AQT==5){
        return qType.push('Dropdown ')
      }
      if(AQT==6){
        return qType.push('Text Box ')
      }
      if(AQT==7){
        return qType.push('Slider ')
      }
      if(AQT==8){
        return qType.push('Date Picker ')
      }
      if(AQT==9){
        return qType.push('Custom Form ')
      }
      if(AQT==10){
        return qType.push('Checkbox ')
      }
      if(AQT==11){
        return qType.push('Picture Choice ')
      }
      if(AQT==12){
        return qType.push('File Uploading ')
      }
      if(AQT==13){
        return qType.push('Signature ')
      }
      if(AQT==14){
        return qType.push('Yes/No ')
      }
      if(AQT==15){
        return qType.push('Matrix ')
      }
      if(AQT==16){
        return qType.push('Multiple Textboxes')
      }
      if(AQT==17){
        return qType.push('Multiple Star Rating')
      }
    })
    return qType.toString();
  }
  //=====================================================================================================
  allQuestionTypes = [];
  getAllQuestionType(){
        this.service.getAllQuestionTypes().subscribe((result: any) => {
      console.log("GET ALL Question Types", result)
      this.allQuestionTypes = result;
        })
      
  }
   //========================================  isAvailable  ==================================================== 
    isAvailable(plan_module_services , allServiceId){
      let is_available = false;
      let i=0
       for(i;i<plan_module_services.length;i++){
        if(plan_module_services[i].moduleServiceId == allServiceId ){
          is_available = true;
          break;
        }
       }
      //  console.log(i,"---------------",plan_module_services.length);
       if(i == plan_module_services.length || is_available==true)
       return is_available;
    
    }
   //========================================  isQuestionAvailable  ====================================================  
    isQuestionAvailable(availableQuestion,allQuestionTypeID){
       let is_available = false;
       let availableQuestionArray = availableQuestion.split(',').map(Number)
      let i=0;
      for(i;i<availableQuestionArray.length;i++){
        if(availableQuestionArray[i] == allQuestionTypeID ){
          is_available = true;
          break;
        }
       }
       if(i == availableQuestionArray.length || is_available==true)
       return is_available;
    
  //      availableQuestionArray.map((AQA)=>{
  //        if(AQA==allQuestionTypeID){
  //         is_available = true; 
  //         break;
  //       }
  // })
  
      //  if(plan_module_service.moduleServiceId==9 ){
      //    if( allQuestionTypeID == plan_module_service.id){
      
      //   return is_available = true;
      //    }
      //  }else{
      //    return is_available = false;
      //  }
  
       
       
      //  plan_module_service.map((q)=>{
      //       if(q.moduleServiceId == 9){
      //         let allQuestions =  q.question_types.split(',').map(Number)
      //         this.allQuestionTypes.map((AQT)=>{
      //         allQuestions.map((qt)=>{
      //           if(qt==AQT.id){
      //             return is_available = true;
      //           }
      //         })
      //       })
      //     }
      //     })
    }
  //=====================================================================================================
  //=====================================================================================================
  //=====================================================================================================

}

